import { PlayerButtonPopup } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import {
  $signInToWatchTranslations,
  SignInToWatchPopup,
} from '../SignInToWatchPopup'

interface PlayerSignInToWatchButtonParams {
  openSignInToWatchPopupEvent: () => void
}

export const PlayerSignInToWatchButton = ({
  openSignInToWatchPopupEvent,
}: PlayerSignInToWatchButtonParams) => {
  const signInToWatchTranslations = useUnit($signInToWatchTranslations)
  return (
    <>
      <PlayerButtonPopup
        title={signInToWatchTranslations.signInToWatch}
        onSubmit={openSignInToWatchPopupEvent}
      />
      <SignInToWatchPopup />
    </>
  )
}
